"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultWidth = exports.getDefaultWidth = exports.defaultWidth = exports.TabletMobile = exports.Tablet = exports.MobileElse = exports.Mobile = exports.HagDesktop = exports.GqGlamDesktop = exports.DesktopTablet = exports.DesktopElse = exports.Desktop = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Default rendering to mobile
var defaultWidth = 760;
exports.defaultWidth = defaultWidth;

var setDefaultWidth = function setDefaultWidth(width) {
  exports.defaultWidth = defaultWidth = width;
};

exports.setDefaultWidth = setDefaultWidth;

var getDefaultWidth = function getDefaultWidth() {
  return defaultWidth;
};

exports.getDefaultWidth = getDefaultWidth;

var Desktop = function Desktop(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 992,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.Desktop = Desktop;

var GqGlamDesktop = function GqGlamDesktop(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 1330,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.GqGlamDesktop = GqGlamDesktop;

var HagDesktop = function HagDesktop(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 1500,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.HagDesktop = HagDesktop;

var DesktopTablet = function DesktopTablet(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 768,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.DesktopTablet = DesktopTablet;

var Tablet = function Tablet(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 768,
    maxWidth: 992,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.Tablet = Tablet;

var TabletMobile = function TabletMobile(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    maxWidth: 992,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.TabletMobile = TabletMobile;

var Mobile = function Mobile(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    maxWidth: 767,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.Mobile = Mobile;

var DesktopElse = function DesktopElse(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    maxWidth: 992,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.DesktopElse = DesktopElse;

var MobileElse = function MobileElse(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactResponsive["default"], _extends({}, props, {
    minWidth: 768,
    values: {
      deviceWidth: defaultWidth
    }
  }));
};

exports.MobileElse = MobileElse;